"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseFileUploadError = exports.responseFetchError = exports.appAxios = void 0;
/* ========================================================================
    Axios
 ========================================================================== */
const axios_1 = __importStar(require("axios"));
// Axios settings
const token = document.head.querySelector('meta[name="csrf-token"]');
const appAxios = axios_1.default.create({
    headers: {
        "X-Requested-With": "XMLHttpRequest",
    },
    timeout: 1200000,
});
exports.appAxios = appAxios;
if (token) {
    appAxios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
}
else {
    console.error("CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token");
}
/**
 * データフェッチ共通エラーレスポンス
 *
 * @param {AxiosError<AppError>} errors
 */
const responseFetchError = (errors) => {
    if (errors.response) {
        // HTTPエラー
        alert(`${errors.response.data.message}\nお手数をおかけいたしますが、再度お申し込みし直していただけますようお願いいたします。`);
        // タイムアウト
    }
    else if (errors.code === axios_1.AxiosError.ECONNABORTED) {
        alert("処理の実行中にタイムアウトが発生しました。");
        // 通信失敗
    }
    else {
        alert(errors.message);
    }
};
exports.responseFetchError = responseFetchError;
/**
 * ファイルアップロード共通エラーレスポンス
 *
 * @param {AxiosError<AppError>} errors
 */
const responseFileUploadError = (errors) => {
    if (errors.response) {
        // バリデーションエラー
        if (errors.response.data.errors) {
            alert(errors.response.data.errors[laravel.uploadFieldName][0]);
            // HTTPエラー
        }
        else {
            alert(`${errors.response.data.message}\nお手数をおかけいたしますが、再度お申し込みし直していただけますようお願いいたします。`);
        }
        // タイムアウト
    }
    else if (errors.code === axios_1.AxiosError.ECONNABORTED) {
        alert("処理の実行中にタイムアウトが発生しました。");
        // 通信失敗
    }
    else {
        alert(errors.message);
    }
};
exports.responseFileUploadError = responseFileUploadError;
